const apiConfigs = {
  "regional": {
    "apiHost": "https://api.mit.edu",
    "paths": {
      "apiPath": "mitid-v2",
      "digitalId": "digital-id-v1"
    }
  },
  "global": {
    "apiHost": "https://mitid.mit.edu/api",
    "paths": {
      "apiPath": "mitid/v2",
      "digitalId": "digital-id/v1"
    }
  }
};
export default apiConfigs;